import { Component } from '@theme/component';

class EscProductCard extends Component {
  // requiredRefs = ['quickAddModal'];

  #quickAddModalCopy = null;

  connectedCallback() {
    super.connectedCallback();

    this.fetchQuickAddModal();
    // this.#copyModal()
  }

  fetchQuickAddModal() {
    fetch(`/products/${this.dataset.productHandle}?sections=quick-add-modal`)
    .then(resp => resp.json())
    .then(data => {
      const html = data['quick-add-modal'];
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const section = tempDiv.firstElementChild;

      if (!document.querySelector('style[data-section-id="quick-add-modal"]')) {
        const style = section?.querySelector('style');
        
        if (style) {
          style.setAttribute('data-section-id', 'quick-add-modal');
          document.head.appendChild(style.cloneNode(true));
        }
      }

      this.#quickAddModalCopy = section.querySelector('esc-quick-add-modal')?.cloneNode(true);
    });
  }

  showModal() {
    if (this.#quickAddModalCopy) {
      document.body.appendChild(this.#quickAddModalCopy);
    }

    this.#quickAddModalCopy?.showModal();
  }
}

if (!customElements.get('esc-product-card')) {
  	customElements.define('esc-product-card', EscProductCard);
}